// Shared constants imports (must be at top)
import { ORDER_SOURCES, SHOPIFY_SOURCES, TRENDYOL_SOURCES, HEPSIBURADA_SOURCES, MARKETPLACE_SOURCES, ALL_SOURCES, SOURCE_LABELS } from '../shared/constants/sources';
import type { OrderSource } from '../shared/constants/sources';
import {
  INVOICE_STATUS,
  DELIVERY_STATUS,
  ORDER_TYPE,
  PAYMENT_TYPE,
  PRODUCT_TYPE,
  IADE_DURUMU,
  TEKLIF_DURUMU,
  ALL_INVOICE_STATUSES,
  ALL_DELIVERY_STATUSES,
  ALL_ORDER_TYPES,
  ALL_PAYMENT_TYPES,
  ALL_PRODUCT_TYPES,
  ALL_IADE_DURUMU,
  ALL_TEKLIF_DURUMU,
  TEKLIF_SANAL_FILTRELERI,
  ODEME_YONTEMI,
  ALL_ODEME_YONTEMI,
  ODEME_DURUMU,
  ALL_ODEME_DURUMU,
  ENTEGRASYON_LOG_DURUMU,
  HB_KONTROL_FARK_TURU,
  HB_KONTROL_LISTESI,
  HB_KONTROL_DUZELTME,
  HB_KONTROL_DUZELTILMEME_NEDENI,
  HB_KONTROL_ATLAMA_NEDENI
} from '../shared/constants/statuses';
import type {
  InvoiceStatusType,
  DeliveryStatusType,
  OrderType as OrderTypeValue,
  PaymentType,
  IadeDurumuType,
  TeklifDurumuType,
  OdemeYontemiType,
  OdemeDurumuType,
  HbKontrolFarkTuruType,
  HbKontrolListesiType,
  HbKontrolDuzeltmeType,
  HbKontrolDuzeltilmemeNedeniType,
  HbKontrolAtlamaNedeniType
} from '../shared/constants/statuses';
import {
  MUSTERI_TURU,
  MUSTERI_KAYNAK,
  LEAD_DURUM,
  AKTIVITE_TURU,
  AKTIVITE_SONUC,
  AKTIVITE_KAYNAK,
  ESLESTIRME_DURUM,
  ALL_MUSTERI_TURU,
  ALL_MUSTERI_KAYNAK,
  ALL_LEAD_DURUM,
  ALL_AKTIVITE_TURU,
  ALL_AKTIVITE_SONUC,
  SECILEBILIR_AKTIVITE_TURLERI,
  SECILEBILIR_AKTIVITE_SONUCLARI,
  VARSAYILAN_MUSTERI_TURU,
  VARSAYILAN_LEAD_DURUM,
  SEKTOR,
  ALL_SEKTOR
} from '../shared/constants/customer';
import type {
  MusteriTuru,
  MusteriKaynak,
  LeadDurum,
  AktiviteTuru,
  AktiviteSonuc,
  Sektor
} from '../shared/constants/customer';
import { ROLES, EDIT_ROLES, CUSTOMER_EDIT_ROLES, ADMIN_ONLY, ALL_ROLES, VIEW_ROLES, PRODUCTION_VIEW_ROLES, ACCOUNTING_ROLES, NON_VIEW_ROLES } from '../shared/constants/roles';
import type { RoleType } from '../shared/constants/roles';
import { KULLANICI_ISLEM_TIPI, GIRIS_HATA_NEDENI } from '../shared/constants/kullanici';
import type { KullaniciIslemTipi, GirisHataNedeni } from '../shared/constants/kullanici';
import { TRENDYOL_VARSAYILAN_KOMISYON, TRENDYOL_PLATFORM_HIZMET_BEDELI, KARGO_FIRMALARI, IADE_NEDENLERI } from '../shared/constants/businessRules';
import { MALZEME_KATEGORI, MALZEME_KATEGORI_LABELS, MALZEME_KATEGORI_VALUES, MALZEME_BIRIM, MALZEME_BIRIM_LABELS, MALZEME_BIRIM_VALUES, MALZEME_FIYAT_KAYNAGI, ALL_MALZEME_FIYAT_KAYNAGI } from '../shared/constants/materials';
import type { MalzemeFiyatKaynagi } from '../shared/constants/materials';
// Açılır liste kayıttaki değeri gizlemesin — TEK NOKTA (rota 2.9)
import { degerFarkindaSecenekler } from '../utils/selectOptions';
import type { Secenek } from '../utils/selectOptions';

// Re-export sources
export { ORDER_SOURCES, SHOPIFY_SOURCES, TRENDYOL_SOURCES, HEPSIBURADA_SOURCES, MARKETPLACE_SOURCES, ALL_SOURCES, SOURCE_LABELS };
export type { OrderSource };

export {
  INVOICE_STATUS,
  DELIVERY_STATUS,
  ORDER_TYPE,
  PAYMENT_TYPE,
  PRODUCT_TYPE,
  IADE_DURUMU,
  TEKLIF_DURUMU,
  ALL_INVOICE_STATUSES,
  ALL_DELIVERY_STATUSES,
  ALL_ORDER_TYPES,
  ALL_PAYMENT_TYPES,
  ALL_PRODUCT_TYPES,
  ALL_IADE_DURUMU,
  ALL_TEKLIF_DURUMU,
  ODEME_YONTEMI,
  ALL_ODEME_YONTEMI,
  ODEME_DURUMU,
  ALL_ODEME_DURUMU,
  ENTEGRASYON_LOG_DURUMU,
  HB_KONTROL_FARK_TURU,
  HB_KONTROL_LISTESI,
  HB_KONTROL_ATLAMA_NEDENI
};
export type { OdemeDurumuType };

// Re-export müşteri modülü kümeleri (bileşenler tek yerden import etsin)
export {
  MUSTERI_TURU,
  MUSTERI_KAYNAK,
  LEAD_DURUM,
  AKTIVITE_TURU,
  AKTIVITE_SONUC,
  AKTIVITE_KAYNAK,
  ESLESTIRME_DURUM,
  ALL_MUSTERI_TURU,
  ALL_MUSTERI_KAYNAK,
  ALL_LEAD_DURUM,
  ALL_AKTIVITE_TURU,
  ALL_AKTIVITE_SONUC,
  SECILEBILIR_AKTIVITE_TURLERI,
  SECILEBILIR_AKTIVITE_SONUCLARI,
  VARSAYILAN_MUSTERI_TURU,
  VARSAYILAN_LEAD_DURUM,
  SEKTOR,
  ALL_SEKTOR
};
export type { MusteriTuru, MusteriKaynak, LeadDurum, AktiviteTuru, AktiviteSonuc, Sektor, OdemeYontemiType };

// Ürün türü etiketleri (UI-only) — TEK KAYNAK.
// Dropdown, boş liste mesajı ve ürün formu buradan okur; inline label yazma.
export const PRODUCT_TYPE_LABELS: Record<string, string> = {
  [PRODUCT_TYPE.STANDART]: 'Standart Ürün',
  [PRODUCT_TYPE.BUNDLE]: 'Bundle (Paket)',
  [PRODUCT_TYPE.YEDEK_PARCA]: 'Yedek Parça',
  [PRODUCT_TYPE.SERVIS]: 'Servis / Hizmet'
};

export const PRODUCT_TYPE_OPTIONS = ALL_PRODUCT_TYPES.map((v) => ({
  value: v,
  label: PRODUCT_TYPE_LABELS[v] || v
}));

// Kargo Firmaları — kodlar shared'da (`KARGO_FIRMALARI`), etiketler burada (UI-only).
// Liste kod kümesinden TÜRETİLİR; elle sıralanmış ikinci bir liste tutulmaz. Sebebi:
// pazaryeri eşlemelerinin ürettiği kodlar (HEPSIJET, YURTICI, MNG...) dropdown'da
// karşılıksız kalırsa `Select` seçili değeri gösteremez ve kullanıcı başka bir alanı
// kaydederken kargo firması silinir (rota 1.21).
//
// SAAS-COUPLING: görünen adlar TrioCare'in taşıyıcıları ve çalışma biçimi (EGE ULAŞIM, Kendi
// Aracımızla, Fabrika Teslim) — hardcoded — çıkarmada adlar kiracının kargo tablosundan gelir;
// kod kümesinin etiketi shared/constants/businessRules'ta.
export const KARGO_FIRMA_LABELS: Record<string, string> = {
  NAKKARGO: 'NAKKARGO',
  EGE_ULASIM: 'EGE ULAŞIM',
  HOROZ: 'HOROZ KARGO',
  ARAS: 'ARAS KARGO',
  GPSLINE: 'GPSLINE KARGO',
  KENDI_ARACIMIZLA: 'Kendi Aracımızla',
  FABRIKA_TESLIM: 'Fabrika Teslim',
  ALICI_ODEMELI: 'Alıcı Ödemeli',
  Diger: 'Diğer / Özel Kurye',
  YURTICI: 'YURTİÇİ KARGO',
  MNG: 'MNG KARGO',
  SURAT: 'SÜRAT KARGO',
  PTT: 'PTT KARGO',
  SENDEO: 'SENDEO KARGO',
  HEPSIJET: 'HEPSIJET',
  TRENDYOL_EXPRESS: 'Trendyol Express'
};

export const SHIPPING_COMPANIES = KARGO_FIRMALARI.map((v) => ({
  value: v,
  label: KARGO_FIRMA_LABELS[v] || v
}));

// Kargo firması gösterimi — TEK NOKTA (rota 1.21). Bilinmeyen bir kod gelirse etiket
// yerine kodun kendisi gösterilir; değer asla gizlenmez. Eskiden iki okuma noktası
// farklı davranıyordu: sipariş kartı ham değere düşüyor, iade kartı '—' basıp veriyi
// saklıyordu. İkisi de artık buradan geçiyor.
export const kargoFirmasiLabel = (value?: string | null): string =>
  value ? KARGO_FIRMA_LABELS[value] || value : '—';

// ─────────────────────────────────────────────────────────────────────────────
// Sipariş kaynağı yardımcıları — TEK NOKTA (rota 1.17)
//
// "Bu sipariş Shopify'dan mı geldi, Trendyol'dan mı" kontrolü sekiz yerde elle
// yazılıydı (`kaynak === X || kaynak === Y`). Yeni bir mağaza açıldığında sekiz
// yere birden dokunmak gerekiyordu; biri unutulursa o ekran siparişi elle
// girilmiş sanıp düzenlemeye açardı. Kaynak kümeleri shared'da, kontrol burada.
//
// ⚠️ İSİM TUZAĞI: `isOtomatikKaynak` = Shopify + Trendyol. Shared'daki
// `MARKETPLACE_SOURCES` ise Trendyol + Hepsiburada'dır — aynı kelime, FARKLI küme.
// Buradaki soru "pazaryeri mi" değil, "entegrasyondan mı geldi, yani alanlarını
// bizim ekranımız mı yazdı"dır. Bir yerde `MARKETPLACE_SOURCES.includes(...)`
// görürsen onu bu yardımcılarla karıştırma.
//
// Hepsiburada bu kümede YOK ve bu BİLEREK böyle. Sebebi rota 1.23'te ölçüldü:
// Hepsiburada, kaynağı elle de seçilebilen TEK entegrasyon (`MANUAL_SOURCE_OPTIONS`
// yalnız HARICI + iki HB mağazasını sunar). Yani "kaynağı HB" demek "webhook'tan
// geldi" demek değil. Kilit kararı için `isEntegrasyonSiparisi` kullan.
// ─────────────────────────────────────────────────────────────────────────────
const kaynakKumesindeMi = (kume: readonly string[], kaynak?: string | null): boolean =>
  !!kaynak && kume.includes(kaynak);

export const isShopifyKaynak = (kaynak?: string | null): boolean =>
  kaynakKumesindeMi(SHOPIFY_SOURCES, kaynak);

export const isTrendyolKaynak = (kaynak?: string | null): boolean =>
  kaynakKumesindeMi(TRENDYOL_SOURCES, kaynak);

/** Shopify VEYA Trendyol — entegrasyondan gelen, alanları dışarıdan yazılan sipariş. */
export const isOtomatikKaynak = (kaynak?: string | null): boolean =>
  isShopifyKaynak(kaynak) || isTrendyolKaynak(kaynak);

export const isHepsiburadaKaynak = (kaynak?: string | null): boolean =>
  kaynakKumesindeMi(HEPSIBURADA_SOURCES, kaynak);

/**
 * Sipariş detayındaki alan kilitlerinin TEK ölçütü (rota 1.23).
 *
 * Soru "kaynağı pazaryeri mi" değil, **"bu siparişi dışarıdaki sistem mi yazıyor"**.
 * CRM'de elle değiştirilirse iki taraf sessizce ayrışır ve kimse fark etmez; kilit
 * bunu engeller.
 *
 * Shopify ve Trendyol'da kaynak tek başına yeter: o iki platform arayüzden elle
 * seçilemiyor (`MANUAL_SOURCE_OPTIONS`), yani kaynağı Shopify/Trendyol olan her
 * sipariş webhook'tan gelmiştir.
 *
 * Hepsiburada FARKLI: kaynağı açılır listeden elle de seçilebiliyor. Canlıda
 * ölçüldü (2026-09-05): 8 HB siparişinin yalnız **2'si** webhook'tan, **6'sı elle**
 * girilmiş. Kaynağa bakıp kilitlemek o altısını haksız yere dondururdu — elle
 * girilen siparişi operasyonun düzenleyebilmesi gerekir. Ayırt edici alan
 * `dis_siparis_id`: onu yalnız entegrasyonlar yazar (`hepsiburadaService`,
 * `trendyolService`, `shopifyService`), sipariş formu boş bırakır.
 *
 * Shopify ve Trendyol için kural BİLEREK değiştirilmedi: canlıda 14 Shopify
 * siparişinin `dis_siparis_id`'si boş (eski/elle kayıtlar) ve 106 HARICI siparişin
 * dolu. Ölçütü hepsine birden uygulamak o 120 siparişin kilidini sessizce
 * ters çevirirdi — bu maddenin işi o değil.
 */
// `disSiparisId` BİLEREK opsiyonel değil: unutulursa HB kilidi sessizce açılırdı.
// Zorunlu (ama null kabul eden) parametre, o hatayı derleme zamanında yakalar.
export const isEntegrasyonSiparisi = (
  kaynak: string | null | undefined,
  disSiparisId: string | number | null | undefined
): boolean => {
  if (isOtomatikKaynak(kaynak)) return true;
  if (!isHepsiburadaKaynak(kaynak)) return false;
  return disSiparisId !== null && disSiparisId !== undefined && String(disSiparisId).trim() !== '';
};

// Re-export roles from shared
export { ROLES, EDIT_ROLES, CUSTOMER_EDIT_ROLES, ADMIN_ONLY, ALL_ROLES, VIEW_ROLES, PRODUCTION_VIEW_ROLES, ACCOUNTING_ROLES, NON_VIEW_ROLES };
export type { RoleType } from '../shared/constants/roles';

// Hangi rolün hangi sayfayı açabildiği `constants/sayfaRolleri.ts`te (rota 3.39).
// Rapor merkezinin listesi (eski `RAPOR_HUB_ROLLERI`, rota 3.37) oraya taşındı:
// rota kapısı, kenar çubuğu ve sayfa içi bağlantılar aynı satırı okuyor.

// Malzeme kategorileri (shared) + dropdown option'ları (UI)
export { MALZEME_KATEGORI, MALZEME_KATEGORI_LABELS, MALZEME_KATEGORI_VALUES };
export const MALZEME_KATEGORI_OPTIONS = MALZEME_KATEGORI_VALUES.map((v) => ({
  value: v,
  label: MALZEME_KATEGORI_LABELS[v] || v
}));

// Kategori renkleri (UI-only) — badge için Tailwind sınıfları. 13 ayrı ton.
// Tam literal string'ler (Tailwind JIT taraması bulsun diye — dinamik birleştirme yapma).
export const MALZEME_KATEGORI_COLORS: Record<string, string> = {
  PROFIL: 'bg-blue-100 text-blue-800',
  MOBILYA: 'bg-amber-100 text-amber-800',
  MOTOR: 'bg-red-100 text-red-800',
  BASLIK: 'bg-purple-100 text-purple-800',
  SARF: 'bg-slate-100 text-slate-700',
  SUNGER: 'bg-pink-100 text-pink-800',
  DERI: 'bg-orange-100 text-orange-800',
  YATAK_ALT: 'bg-teal-100 text-teal-800',
  BURC: 'bg-cyan-100 text-cyan-800',
  LAMA: 'bg-indigo-100 text-indigo-800',
  TRANSMISYON: 'bg-violet-100 text-violet-800',
  LAZER_KESIM: 'bg-rose-100 text-rose-800',
  DIGER: 'bg-gray-100 text-gray-600'
};

// Malzeme birimleri (shared) + dropdown option'ları (UI)
export { MALZEME_BIRIM, MALZEME_BIRIM_LABELS, MALZEME_BIRIM_VALUES };
export const MALZEME_BIRIM_OPTIONS = MALZEME_BIRIM_VALUES.map((v) => ({
  value: v,
  label: MALZEME_BIRIM_LABELS[v] || v
}));

// Malzeme fiyat geçmişinin kaynağı (shared). Etiket haritası kümenin tamamını kapsar;
// shared'a eklenip etiketi yazılmayan değer tsc'yi kırar.
export { MALZEME_FIYAT_KAYNAGI, ALL_MALZEME_FIYAT_KAYNAGI };
export type { MalzemeFiyatKaynagi };
export const MALZEME_FIYAT_KAYNAGI_LABELS: Record<MalzemeFiyatKaynagi, string> = {
  [MALZEME_FIYAT_KAYNAGI.EKRAN]: 'Malzeme ekranı',
  [MALZEME_FIYAT_KAYNAGI.VERITABANI]: 'Veritabanı',
  [MALZEME_FIYAT_KAYNAGI.BASLANGIC]: 'İlk kayıt',
};
export const malzemeFiyatKaynagiLabel = (value?: string | null): string =>
  value ? MALZEME_FIYAT_KAYNAGI_LABELS[value as MalzemeFiyatKaynagi] || value : '—';

// ─────────────────────────────────────────────────────────────────────────────
// Enum etiketleri, renkleri ve açılır liste seçenekleri — TEK KAYNAK (rota 2.2)
//
// Kural: **değer kümesi shared'da, etiket ve renk burada.** Aşağıdaki hiçbir
// listede enum değeri elle yazılmaz; anahtarlar `shared/constants`'tan gelir,
// açılır liste seçenekleri de o kümelerden TÜRETİLİR.
//
// Neden: eskiden seçenek listeleri elle yazılıydı. Shared'a yeni bir değer
// eklendiğinde açılır liste sessizce eksik kalıyordu — `TEKLIF_DURUMU_OPTIONS`
// bunun canlı örneğiydi: `SURESI_DOLDU` listede yoktu, sipariş detayı o teklifi
// KIRMIZI zeminde "⏳ Beklemede" diye gösteriyordu (renk haritasında değer vardı,
// etiket haritasında yoktu), sipariş listesi ise emoji yerine "-" basıyordu.
//
// `Record<XType, string>` tipleri bunun tekrarını derleme zamanında engeller:
// shared'a bir değer eklenip buraya etiket yazılmazsa `tsc` kırmızıya döner.
// ─────────────────────────────────────────────────────────────────────────────

// ── Sipariş kaynağı: etiket + renk ──
//
// Ad tablosu (`SOURCE_LABELS`) shared'da: arka yüz de üretim Excel'inde ve günlük
// e-postada aynı adı basıyor. Renkler yalnız ön yüzün işi, burada.
//
// SAAS-COUPLING: mağaza renkleri TrioCare'in mağazalarına özel — hardcoded —
// extraction'da kanal tablosuna taşınır: tenant mağazasının rengini kendi tanımlar.

// Kaynak gösterimi — TEK NOKTA. `SOURCE_LABELS[x] || x` altı yerde ayrı yazılıydı.
// Bilinmeyen kod GİZLENMEZ, kodun kendisi gösterilir: `siparis_kaynak` ENUM'unda
// bugün kullanılmayan dört legacy değer duruyor (PROBED, LABORTECH, TRENDYOL,
// HEPSIBURADA — canlıda 0 sipariş), biri geri gelirse ekranda boşluk değil değer
// görünsün.
// Prototip adı (`constructor` gibi) etiket sayılmaz: düz indeksleme kalıtımla gelen
// fonksiyonu bulur. Arka yüz ikizi `formatHelper.kaynakEtiketi` aynı kuralla çalışır.
export const kaynakLabel = (value?: string | null): string => {
  if (!value) return '—';
  return Object.prototype.hasOwnProperty.call(SOURCE_LABELS, value)
    ? SOURCE_LABELS[value as OrderSource]
    : value;
};

// Badge zemini + yazı rengi (Tailwind sınıfları; JIT taraması bulsun diye tam literal).
export const SOURCE_COLORS: Record<OrderSource, string> = {
  [ORDER_SOURCES.SHOPIFY_PROBED]: 'bg-blue-100 text-blue-800',
  [ORDER_SOURCES.SHOPIFY_LABORTECH]: 'bg-purple-100 text-purple-800',
  [ORDER_SOURCES.HARICI]: 'bg-gray-100 text-gray-800',
  [ORDER_SOURCES.TRENDYOL_LABORTECH]: 'bg-orange-100 text-orange-800',
  [ORDER_SOURCES.TRENDYOL_TRIOCARE]: 'bg-orange-200 text-orange-900',
  [ORDER_SOURCES.HEPSIBURADA_LABORTECH]: 'bg-yellow-100 text-yellow-800',
  [ORDER_SOURCES.HEPSIBURADA_TRIOCARE]: 'bg-amber-100 text-amber-800'
};

// Rozet tonunun renk değeri: SVG ile çizilen rozet (kanal grafiği) Tailwind sınıfını
// okuyamaz, dolgu rengi ister. Yalnız SOURCE_COLORS'ın tonları; değerler Tailwind 3
// paletiyle aynı olmak zorunda (enumEtiketleri.test.ts paletin kendisiyle karşılaştırır).
// Mağaza başına renk burada değil, yalnız SOURCE_COLORS'ta seçilir.
export const ROZET_TON_RENGI: Record<string, string> = {
  'blue-100': '#dbeafe',
  'blue-800': '#1e40af',
  'purple-100': '#f3e8ff',
  'purple-800': '#6b21a8',
  'gray-100': '#f3f4f6',
  'gray-800': '#1f2937',
  'orange-100': '#ffedd5',
  'orange-200': '#fed7aa',
  'orange-800': '#9a3412',
  'orange-900': '#7c2d12',
  'yellow-100': '#fef9c3',
  'yellow-800': '#854d0e',
  'amber-100': '#fef3c7',
  'amber-800': '#92400e',
};

// Kaynak rozetinin zemin ve yazı rengi, listedeki rozetle (SOURCE_COLORS) aynı. Tanınmayan
// kaynak listedeki gibi HARICI'nin rengine düşer; prototip adı (`constructor`) kaynak sayılmaz.
export const kaynakRozetRengi = (kaynak: string): { zemin: string; yazi: string } => {
  const siniflar = Object.prototype.hasOwnProperty.call(SOURCE_COLORS, kaynak)
    ? SOURCE_COLORS[kaynak as OrderSource]
    : SOURCE_COLORS[ORDER_SOURCES.HARICI];
  const ton = (onek: string) =>
    ROZET_TON_RENGI[(siniflar.split(' ').find((s) => s.startsWith(onek)) ?? '').slice(onek.length)];
  return { zemin: ton('bg-'), yazi: ton('text-') };
};

// Sipariş NUMARASININ yazı rengi — badge zemininden ayrı bir gösterim.
// Sipariş listesindeki `OrderSiparisNoBadge` ile Termin/Teslim raporu bu haritayı
// ayrı ayrı yazıyordu; ikisi de artık buradan okuyor.
//
// Yazı tonu kaynağın rozetindeki tonla aynı, zeminden koyu: numaraya bakan
// kaynağı rozetteki renginden tanır.
//
// Yalnız üç kaynağın rengi var; kalan dördü çağıranın kendi varsayılanına düşer
// (liste `text-gray-900`, rapor `text-gray-800` — o fark da bilerek korundu).
export const SOURCE_TEXT_COLORS: Partial<Record<OrderSource, string>> = {
  [ORDER_SOURCES.SHOPIFY_PROBED]: 'text-blue-700',
  [ORDER_SOURCES.SHOPIFY_LABORTECH]: 'text-purple-700',
  [ORDER_SOURCES.HARICI]: 'text-gray-600'
};

// Kanal dağılımı grafiği (hex — Recharts Tailwind sınıfı okumaz).
export const CHART_SOURCE_COLORS: Record<OrderSource | 'default', string> = {
  [ORDER_SOURCES.SHOPIFY_PROBED]: '#3b82f6',
  [ORDER_SOURCES.SHOPIFY_LABORTECH]: '#8b5cf6',
  [ORDER_SOURCES.HARICI]: '#9ca3af',
  [ORDER_SOURCES.TRENDYOL_LABORTECH]: '#F97316',
  [ORDER_SOURCES.TRENDYOL_TRIOCARE]: '#EA580C',
  [ORDER_SOURCES.HEPSIBURADA_LABORTECH]: '#EAB308',
  [ORDER_SOURCES.HEPSIBURADA_TRIOCARE]: '#D97706',
  default: '#cbd5e1'
};

export const SOURCE_OPTIONS = ALL_SOURCES.map((source) => ({
  value: source,
  label: kaynakLabel(source)
}));

// [YENİ] Manuel Sipariş İçin Kaynak Seçenekleri (Roadmap 3.2.2)
//
// SAAS-COUPLING: iki HB mağaza kimliği TrioCare'e özel — hardcoded —
// extraction'da kanal tablosundan türer (tenant hangi kanalları elle
// girebileceğini kendi seçer).
//
// ⚠️ BU LİSTE KİLİT ÖLÇÜTÜNÜ TAŞIYOR (rota 1.24). `isEntegrasyonSiparisi`
// `dis_siparis_id` testini YALNIZ Hepsiburada'ya uygular; gerekçesi, elle
// seçilebilen tek entegrasyonun HB olması. Buraya HARICI ve HB dışında bir kaynak
// eklenirse o kaynağın elle girilmiş siparişleri kaynağa bakılarak kilitlenmeye
// devam eder — sessiz hata. `kaynakYardimcilari.test.ts` bu bağı doğrular; test
// kırmızıya dönerse önce `isEntegrasyonSiparisi`'yi (iki kopyası da) genişlet.
export const MANUAL_SOURCE_OPTIONS = [
  ORDER_SOURCES.HARICI,
  ORDER_SOURCES.HEPSIBURADA_LABORTECH,
  ORDER_SOURCES.HEPSIBURADA_TRIOCARE
].map((source) => ({ value: source, label: kaynakLabel(source) }));

// ── Fatura durumu ──
export const INVOICE_LABELS: Record<InvoiceStatusType, string> = {
  [INVOICE_STATUS.KESILECEK]: 'Kesilecek',
  [INVOICE_STATUS.KESILDI]: 'Kesildi',
  [INVOICE_STATUS.IPTAL]: 'İptal',
  [INVOICE_STATUS.IADE_EDILDI]: 'İade Edildi',
  [INVOICE_STATUS.KISMI_IADE]: 'Kısmi İade',
  [INVOICE_STATUS.GEREKMIYOR]: 'Gerekmiyor'
};

export const INVOICE_COLORS: Record<InvoiceStatusType, string> = {
  [INVOICE_STATUS.KESILECEK]: 'bg-orange-100 text-orange-800',
  [INVOICE_STATUS.KESILDI]: 'bg-green-100 text-green-800',
  [INVOICE_STATUS.IPTAL]: 'bg-red-100 text-red-800',
  [INVOICE_STATUS.IADE_EDILDI]: 'bg-violet-100 text-violet-800',  // Tam iade — ciroda yer almaz
  [INVOICE_STATUS.KISMI_IADE]: 'bg-amber-100 text-amber-800',     // Kısmi iade — ciroda kalır, IADE child'lar -sum ile düşer
  [INVOICE_STATUS.GEREKMIYOR]: 'bg-gray-100 text-gray-800'
};

export const INVOICE_OPTIONS = ALL_INVOICE_STATUSES.map((v) => ({
  value: v,
  label: INVOICE_LABELS[v]
}));

// Bilinmeyen durum GİZLENMEZ (rota 1.21 dersi): değerin kendisi görünür.
export const faturaDurumuLabel = (value?: string | null): string =>
  value ? INVOICE_LABELS[value as InvoiceStatusType] || value : '—';

/**
 * Sipariş detayındaki fatura durumu açılır listesi (rota 2.9).
 *
 * Shopify/Trendyol siparişlerinde `IPTAL` SEÇİLEMEZ — iptal kararı platformdan
 * gelir, CRM'den elle verilmez; webhook (`webhookController`, `trendyolController`)
 * yazar. Ama seçilemez olmak GÖRÜNEMEZ olmak değildir: kayıt zaten `IPTAL` ise
 * seçenek listeye geri eklenir, yoksa `Select` değeri gösteremez ve alan boş
 * çıkar. Canlıda 67 sipariş (56 SHOPIFY_PROBED + 7 TRENDYOL_LABORTECH +
 * 4 SHOPIFY_LABORTECH) tam olarak bu durumdaydı — ve `IPTAL` yazan TEK yol
 * entegrasyon olduğu için filtre, gizlediği değerin tek kaynağını gizliyordu.
 */
export const faturaDurumuSecenekleri = (
  entegrasyonSiparisi: boolean,
  mevcut?: string | null
): Secenek[] =>
  entegrasyonSiparisi
    ? degerFarkindaSecenekler(
        INVOICE_OPTIONS.filter((opt) => opt.value !== INVOICE_STATUS.IPTAL),
        mevcut,
        faturaDurumuLabel
      )
    : INVOICE_OPTIONS;

// ── Teslimat durumu ──
export const DELIVERY_LABELS: Record<DeliveryStatusType, string> = {
  [DELIVERY_STATUS.EVET]: 'Teslim Edildi',
  [DELIVERY_STATUS.HAYIR]: 'Bekliyor',
  [DELIVERY_STATUS.KISMI]: 'Kısmi Teslim'
};

export const DELIVERY_COLORS: Record<DeliveryStatusType, string> = {
  [DELIVERY_STATUS.EVET]: 'bg-green-100 text-green-800',
  [DELIVERY_STATUS.HAYIR]: 'bg-yellow-100 text-yellow-800',
  [DELIVERY_STATUS.KISMI]: 'bg-orange-100 text-orange-800'
};

export const DELIVERY_OPTIONS = ALL_DELIVERY_STATUSES.map((v) => ({
  value: v,
  label: DELIVERY_LABELS[v]
}));

// Bilinmeyen durum GİZLENMEZ: değerin kendisi görünür.
export const teslimDurumuLabel = (value?: string | null): string =>
  value ? DELIVERY_LABELS[value as DeliveryStatusType] || value : '—';

// ── Ödeme türü (siparisler.odeme_turu) ──
export const PAYMENT_TYPE_LABELS: Record<PaymentType, string> = {
  [PAYMENT_TYPE.NAKIT]: 'Nakit',
  [PAYMENT_TYPE.KREDI_KARTI]: 'Kredi Kartı',
  [PAYMENT_TYPE.HAVALE]: 'Havale / EFT',
  [PAYMENT_TYPE.BEDELSIZ]: 'Bedelsiz'
};

export const PAYMENT_OPTIONS = ALL_PAYMENT_TYPES.map((v) => ({
  value: v,
  label: PAYMENT_TYPE_LABELS[v]
}));

// Bilinmeyen ödeme türü GİZLENMEZ: değerin kendisi görünür.
export const odemeTuruLabel = (value?: string | null): string =>
  value ? PAYMENT_TYPE_LABELS[value as PaymentType] || value : '—';

// ── Ödeme DURUMU (DB kolonu değil) ──
// Durumu sunucu hesaplar (`SQL_ODEME_DURUMU`); sipariş listesinin ve pano penceresinin
// rozeti etiketi buradan okur. Teklif ve iptal satırında ödeme durumu yoktur, çizgi görünür.
export const ODEME_DURUMU_LABELS: Record<OdemeDurumuType, string> = {
  [ODEME_DURUMU.TEKLIF]: '-',
  [ODEME_DURUMU.IPTAL]: '—',
  [ODEME_DURUMU.IADE]: 'İade',
  [ODEME_DURUMU.BEDELSIZ]: 'Bedelsiz',
  [ODEME_DURUMU.ODENDI]: 'Ödendi',
  [ODEME_DURUMU.KISMI]: 'Kısmi',
  [ODEME_DURUMU.ODENMEDI]: 'Ödenmedi'
};

// Bilinmeyen durum GİZLENMEZ: değerin kendisi görünür.
export const odemeDurumuLabel = (value?: string | null): string =>
  value ? ODEME_DURUMU_LABELS[value as OdemeDurumuType] || value : '—';

// İade durumunun rozet rengi; iki rozetin öteki tonları kendi görünümlerine özel, bu ortak.
export const ODEME_IADE_RENGI = 'bg-violet-50 text-violet-700 border border-violet-200';

// ── Kullanıcı rolü ──
export const ROLE_LABELS: Record<RoleType, string> = {
  [ROLES.ADMIN]: 'Admin',
  [ROLES.OPERASYON]: 'Operasyon',
  [ROLES.GORUNTULEME]: 'Görüntüleme',
  [ROLES.MUHASEBE]: 'Muhasebe',
  [ROLES.PAZARLAMA]: 'Pazarlama',
  [ROLES.TEKNIK]: 'Teknik'
};

export const ROLE_COLORS: Record<RoleType, string> = {
  [ROLES.ADMIN]: 'bg-red-100 text-red-800',
  [ROLES.OPERASYON]: 'bg-blue-100 text-blue-800',
  [ROLES.GORUNTULEME]: 'bg-gray-100 text-gray-800',
  [ROLES.MUHASEBE]: 'bg-emerald-100 text-emerald-800',
  [ROLES.PAZARLAMA]: 'bg-pink-100 text-pink-800',
  [ROLES.TEKNIK]: 'bg-cyan-100 text-cyan-800'
};

export const ROLE_OPTIONS = ALL_ROLES.map((v) => ({
  value: v,
  label: ROLE_LABELS[v]
}));

// ── Kullanıcı değişiklik kaydı ve giriş geçmişi (kümeler shared/constants/kullanici) ──
export const KULLANICI_ISLEM_LABELS: Record<KullaniciIslemTipi, string> = {
  [KULLANICI_ISLEM_TIPI.OLUSTURMA]: 'Oluşturma',
  [KULLANICI_ISLEM_TIPI.GUNCELLEME]: 'Güncelleme',
  [KULLANICI_ISLEM_TIPI.AKTIF]: 'Aktif Yapıldı',
  [KULLANICI_ISLEM_TIPI.PASIF]: 'Pasif Yapıldı',
  [KULLANICI_ISLEM_TIPI.SILME]: 'Silme (Kalıcı)',
  [KULLANICI_ISLEM_TIPI.UNLOCK]: 'Kilit Açıldı',
  [KULLANICI_ISLEM_TIPI.DAVET]: 'Davet Gönderimi',
  [KULLANICI_ISLEM_TIPI.DAVET_IPTAL]: 'Davet İptal',
  [KULLANICI_ISLEM_TIPI.SIFRE_BELIRLEME]: 'Şifre Belirlendi',
  [KULLANICI_ISLEM_TIPI.SIFRE_SIFIRLAMA]: 'Şifre Sıfırlandı',
};

export const KULLANICI_ISLEM_COLORS: Record<KullaniciIslemTipi, string> = {
  [KULLANICI_ISLEM_TIPI.OLUSTURMA]: 'bg-green-100 text-green-800',
  [KULLANICI_ISLEM_TIPI.GUNCELLEME]: 'bg-blue-100 text-blue-800',
  [KULLANICI_ISLEM_TIPI.AKTIF]: 'bg-green-100 text-green-800',
  [KULLANICI_ISLEM_TIPI.PASIF]: 'bg-orange-100 text-orange-800',
  [KULLANICI_ISLEM_TIPI.SILME]: 'bg-red-100 text-red-800',
  [KULLANICI_ISLEM_TIPI.UNLOCK]: 'bg-purple-100 text-purple-800',
  [KULLANICI_ISLEM_TIPI.DAVET]: 'bg-amber-100 text-amber-800',
  [KULLANICI_ISLEM_TIPI.DAVET_IPTAL]: 'bg-orange-100 text-orange-800',
  [KULLANICI_ISLEM_TIPI.SIFRE_BELIRLEME]: 'bg-green-100 text-green-800',
  [KULLANICI_ISLEM_TIPI.SIFRE_SIFIRLAMA]: 'bg-blue-100 text-blue-800',
};

// Bilinmeyen tür GİZLENMEZ: değerin kendisi görünür.
export const kullaniciIslemLabel = (value: string): string =>
  KULLANICI_ISLEM_LABELS[value as KullaniciIslemTipi] || value;

export const GIRIS_HATA_LABELS: Record<GirisHataNedeni, string> = {
  [GIRIS_HATA_NEDENI.USER_NOT_FOUND]: 'Kullanıcı yok',
  [GIRIS_HATA_NEDENI.PASSIVE_USER]: 'Pasif kullanıcı',
  [GIRIS_HATA_NEDENI.ACCOUNT_LOCKED]: 'Hesap kilitli',
  [GIRIS_HATA_NEDENI.WRONG_PASSWORD]: 'Yanlış şifre',
  [GIRIS_HATA_NEDENI.DAVET_BEKLIYOR]: 'Davet bekliyor',
};

// ── Davet durumu (kullanıcı listesi rozeti; durum `components/users/davetDurumu`) ──
export type DavetDurumu = 'bekliyor' | 'suresi_doldu' | 'iptal';

export const DAVET_DURUMU_LABELS: Record<DavetDurumu, string> = {
  bekliyor: 'Davet bekliyor',
  suresi_doldu: 'Davet süresi doldu',
  iptal: 'Davet iptal',
};

export const DAVET_DURUMU_COLORS: Record<DavetDurumu, string> = {
  bekliyor: 'bg-amber-100 text-amber-800 border border-amber-200',
  suresi_doldu: 'bg-red-50 text-red-700 border border-red-200',
  iptal: 'bg-gray-200 text-gray-600 border border-gray-300',
};

// ── Sipariş türü ──
// İki etiket kümesi var ve ikisi de gerekli: uzun olan açılır listede, kısa olan
// ilişkili sipariş kartındaki dar rozette kullanılır.
export const ORDER_TYPE_LABELS: Record<OrderTypeValue, string> = {
  [ORDER_TYPE.SATIS]: 'Satış Siparişi',
  [ORDER_TYPE.YEDEK_PARCA]: 'Yedek Parça',
  [ORDER_TYPE.IADE]: 'İade Alım',
  [ORDER_TYPE.TELAFI]: 'Telafi Gönderim',
  [ORDER_TYPE.IHRACAT]: 'İhracat',
  [ORDER_TYPE.TEKLIF]: 'Teklif / Proforma',
  [ORDER_TYPE.STOK_IMALAT]: 'Stok İmalat'
};

export const ORDER_TYPE_SHORT_LABELS: Record<OrderTypeValue, string> = {
  [ORDER_TYPE.SATIS]: 'Satış',
  [ORDER_TYPE.YEDEK_PARCA]: 'Yedek Parça',
  [ORDER_TYPE.IADE]: 'İade',
  [ORDER_TYPE.TELAFI]: 'Telafi',
  [ORDER_TYPE.IHRACAT]: 'İhracat',
  [ORDER_TYPE.TEKLIF]: 'Teklif',
  [ORDER_TYPE.STOK_IMALAT]: 'Stok İmalat'
};

export const ORDER_TYPE_OPTIONS = ALL_ORDER_TYPES.map((v) => ({
  value: v,
  label: ORDER_TYPE_LABELS[v]
}));

// Bilinmeyen tür GİZLENMEZ: değerin kendisi görünür. Uzun etiket, açılır
// listeyle aynı metin.
export const siparisTuruLabel = (value?: string | null): string =>
  value ? ORDER_TYPE_LABELS[value as OrderTypeValue] || value : '—';

// ── Teklif durumu ──
// Etiket haritası DB ENUM'unun TAMAMINI kapsar (`SURESI_DOLDU` dahil); açılır
// filtre listesi ise ayrı ve BİLEREK farklı: iki pseudo-değer içerir, `SURESI_DOLDU`
// içermez. Bu ayrım eskiden yoktu — tek liste hem filtreydi hem etiket kaynağıydı,
// bu yüzden süresi dolmuş bir teklif "Beklemede" görünüyordu.
export const TEKLIF_DURUMU_EMOJI: Record<TeklifDurumuType, string> = {
  [TEKLIF_DURUMU.BEKLEMEDE]: '⏳',
  [TEKLIF_DURUMU.ONAYLANDI]: '✅',
  [TEKLIF_DURUMU.IPTAL]: '❌',
  [TEKLIF_DURUMU.SURESI_DOLDU]: '⌛',
  [TEKLIF_DURUMU.OLUMSUZ]: '👎'
};

export const TEKLIF_DURUMU_LABELS: Record<TeklifDurumuType, string> = {
  [TEKLIF_DURUMU.BEKLEMEDE]: '⏳ Beklemede',
  [TEKLIF_DURUMU.ONAYLANDI]: '✅ Onaylandı',
  [TEKLIF_DURUMU.IPTAL]: '❌ İptal',
  [TEKLIF_DURUMU.SURESI_DOLDU]: '⌛ Süresi Doldu',
  [TEKLIF_DURUMU.OLUMSUZ]: '👎 Olumsuz'
};

export const TEKLIF_DURUMU_COLORS: Record<TeklifDurumuType, string> = {
  [TEKLIF_DURUMU.BEKLEMEDE]: 'bg-yellow-100 text-yellow-800',
  [TEKLIF_DURUMU.ONAYLANDI]: 'bg-green-100 text-green-800',
  [TEKLIF_DURUMU.IPTAL]: 'bg-gray-100 text-gray-800',
  [TEKLIF_DURUMU.SURESI_DOLDU]: 'bg-red-100 text-red-800',
  [TEKLIF_DURUMU.OLUMSUZ]: 'bg-rose-100 text-rose-800'
};

// [YENİ] Teklif Listesi Dot Renkleri (OrderList teklifColumns için)
export const TEKLIF_DURUMU_DOT_COLORS: Record<TeklifDurumuType, string> = {
  [TEKLIF_DURUMU.BEKLEMEDE]: 'bg-amber-400',
  [TEKLIF_DURUMU.ONAYLANDI]: 'bg-green-500',
  [TEKLIF_DURUMU.IPTAL]: 'bg-gray-400',
  [TEKLIF_DURUMU.SURESI_DOLDU]: 'bg-red-500',
  [TEKLIF_DURUMU.OLUMSUZ]: 'bg-rose-700'
};

// Teklif listesi FİLTRESİ — açılır listeye ne yazılacağı ayrı bir karardır,
// bu yüzden sıra elle verilir. İki değer DB ENUM'unda YOK, backend'de sorguya
// çevrilen pseudo-filtredir:
//   OLUMLU        = ONAYLANDI + siparişe dönüştürülmüş teklifler
//   DONUSTURULDU  = yalnız siparişe dönüştürülmüş olanlar
// `SURESI_DOLDU` listede BİLEREK yok: değeri yazan kod bugün mevcut değil
// (migration 008 bir cron'dan söz ediyor, o cron yazılmadı) ve canlıda 0 teklif
// bu durumda — boş sonuç dönen bir filtre satırı eklemenin faydası yok. Yazan kod
// gelirse buraya bir satır eklenir; etiketi ve rengi zaten hazır.
// İki sanal değer shared'dan gelir (rota 3.29) — `models/order.js` onları sorguya
// çeviriyor, backend'in sorgu şeması da aynı kümeyi kabul ediyor. Düz metin yazma:
// üç taraf ayrışırsa burada seçilebilen bir değer sunucuda 400 ile reddedilir.
const TEKLIF_DURUMU_FILTRE_SIRASI = [
  TEKLIF_DURUMU.BEKLEMEDE,
  TEKLIF_DURUMU.ONAYLANDI,
  TEKLIF_SANAL_FILTRELERI.OLUMLU,
  TEKLIF_SANAL_FILTRELERI.DONUSTURULDU,
  TEKLIF_DURUMU.IPTAL,
  TEKLIF_DURUMU.OLUMSUZ
] as const;

const TEKLIF_PSEUDO_LABELS: Record<string, string> = {
  [TEKLIF_SANAL_FILTRELERI.OLUMLU]: '🌟 Olumlu',
  [TEKLIF_SANAL_FILTRELERI.DONUSTURULDU]: '🔄 Siparişe Dönüştürüldü'
};

export const teklifDurumuLabel = (value?: string | null): string =>
  value
    ? TEKLIF_DURUMU_LABELS[value as TeklifDurumuType] || TEKLIF_PSEUDO_LABELS[value] || value
    : '—';

export const TEKLIF_DURUMU_OPTIONS = TEKLIF_DURUMU_FILTRE_SIRASI.map((v) => ({
  value: v,
  label: teklifDurumuLabel(v)
}));

// ── İade nedeni (siparisler.iade_nedeni — TEXT kolon, kapalı küme) ──
// Küme shared'da (`IADE_NEDENLERI`), çünkü değeri Shopify iade webhook'u da yazıyor.
export const IADE_NEDENI_LABELS: Record<string, string> = {
  HASARLI: 'Hasarlı / Kırık',
  YANLIS_URUN: 'Yanlış Ürün',
  MUSTERI_VAZGECTI: 'Müşteri Vazgeçti',
  EKSIK_URUN: 'Eksik Ürün',
  DIGER: 'Diğer'
};

export const IADE_NEDENI_OPTIONS = IADE_NEDENLERI.map((v) => ({
  value: v,
  label: IADE_NEDENI_LABELS[v] || v
}));

// Bilinmeyen neden GİZLENMEZ (rota 1.21 dersi): kolon TEXT, dışarıdan bir değer
// düşerse ekranda '—' değil değerin kendisi görünür.
export const iadeNedeniLabel = (value?: string | null): string =>
  value ? IADE_NEDENI_LABELS[value] || value : '—';

// ── İade durumu ──
export const IADE_DURUMU_EMOJI: Record<IadeDurumuType, string> = {
  [IADE_DURUMU.BEKLIYOR]: '🔴',
  [IADE_DURUMU.TESLIM_ALINDI]: '🟡',
  [IADE_DURUMU.TAMAMLANDI]: '🟢'
};

export const IADE_DURUMU_LABELS: Record<IadeDurumuType, string> = {
  [IADE_DURUMU.BEKLIYOR]: '🔴 Kargo Bekleniyor',
  [IADE_DURUMU.TESLIM_ALINDI]: '🟡 Teslim Alındı',
  [IADE_DURUMU.TAMAMLANDI]: '🟢 Tamamlandı'
};

export const IADE_DURUMU_OPTIONS = ALL_IADE_DURUMU.map((v) => ({
  value: v,
  label: IADE_DURUMU_LABELS[v]
}));

export const iadeDurumuLabel = (value?: string | null): string =>
  value ? IADE_DURUMU_LABELS[value as IadeDurumuType] || value : '—';

// [YENİ] Dashboard Grafik Renkleri (Roadmap 3.2.4)
export const CHART_COLORS = {
  IC_PAZAR: '#3B82F6', // Mavi
  IHRACAT: '#10B981'   // Yeşil
};

// Trendyol Sabit Değerler (shared/constants/businessRules'dan)
export const TRENDYOL_CONSTANTS = {
  PLATFORM_SERVICE_FEE: TRENDYOL_PLATFORM_HIZMET_BEDELI,
  DEFAULT_COMMISSION_RATE: TRENDYOL_VARSAYILAN_KOMISYON
} as const;

// ─── [FAZ 4] Müşteri Sabitleri ─────────────────────────────────────
//
// Rota 2.2'nin kuralı burada da geçerli: değer kümeleri shared'da
// (`shared/constants/customer.ts`), etiket ve renk burada, açılır liste
// seçenekleri kümeden TÜRETİLİR. `Record<XType, string>` tipleri sayesinde
// shared'a bir değer eklenip buraya etiket yazılmazsa `tsc` kırmızıya döner.

// ── Müşteri türü ──
export const MUSTERI_TURU_LABELS: Record<MusteriTuru, string> = {
  [MUSTERI_TURU.MEVCUT]: 'Mevcut Müşteri',
  [MUSTERI_TURU.POTANSIYEL]: 'Potansiyel Müşteri',
  [MUSTERI_TURU.BAYI_ALTI]: 'Bayi Alt Müşteri',
};

export const MUSTERI_TURU_COLORS: Record<MusteriTuru, string> = {
  [MUSTERI_TURU.MEVCUT]: 'bg-green-100 text-green-800',
  [MUSTERI_TURU.POTANSIYEL]: 'bg-blue-100 text-blue-800',
  [MUSTERI_TURU.BAYI_ALTI]: 'bg-purple-100 text-purple-800',
};

export const MUSTERI_TURU_OPTIONS = ALL_MUSTERI_TURU.map((v) => ({
  value: v,
  label: MUSTERI_TURU_LABELS[v],
}));

// Bilinmeyen tür gizlenmez, kodun kendisi görünür; boş değer "—".
export const musteriTuruLabel = (value?: string | null): string =>
  value ? MUSTERI_TURU_LABELS[value as MusteriTuru] || value : '—';

// Müşteri formunun tür listesi (rota 3.39). "Bayi altı" türünde müşterinin özel
// vade/indirim koşulu devre dışı kalır, koşul gruptan gelir; o yüzden türü oraya
// taşımak ya da oradan çıkarmak ticari alan yetkisi ister (`useAuth().canEdit`,
// sunucu aynası `customerService` ticari alan kilidi). Yetkisi olmayan rolde seçenek
// listeden düşer — ama kayıt zaten bayi altıysa değer GİZLENMEZ (rota 2.9).
export const musteriTuruSecenekleri = (
  bayiAltiSecilebilir: boolean,
  mevcut?: string | null
): Secenek[] =>
  bayiAltiSecilebilir
    ? MUSTERI_TURU_OPTIONS
    : degerFarkindaSecenekler(
        MUSTERI_TURU_OPTIONS.filter((opt) => opt.value !== MUSTERI_TURU.BAYI_ALTI),
        mevcut,
        musteriTuruLabel
      );

// ── Müşteri ilk kaynağı ──
// SAAS-COUPLING: kanal etiketleri ve renkleri TrioCare'in satış kanallarından
// türüyor — hardcoded — extraction'da tenant kanal tanımından beslenir.
// Kümenin kendisi shared'da (`MUSTERI_KAYNAK`); burada yalnız gösterim var.
export const MUSTERI_KAYNAK_LABELS: Record<MusteriKaynak, string> = {
  [MUSTERI_KAYNAK.SHOPIFY]: 'Shopify',
  [MUSTERI_KAYNAK.TRENDYOL]: 'Trendyol',
  [MUSTERI_KAYNAK.HEPSIBURADA]: 'HepsiBurada',
  [MUSTERI_KAYNAK.HARICI]: 'Harici',
  [MUSTERI_KAYNAK.SCRAPING]: 'Scraping',
  [MUSTERI_KAYNAK.FUAR]: 'Fuar',
  [MUSTERI_KAYNAK.B2B_SAHA]: 'B2B / Saha',
  [MUSTERI_KAYNAK.REFERANS]: 'Referans',
  [MUSTERI_KAYNAK.WHATSAPP]: 'WhatsApp',
  [MUSTERI_KAYNAK.INSTAGRAM]: 'Instagram',
  [MUSTERI_KAYNAK.FACEBOOK]: 'Facebook',
  [MUSTERI_KAYNAK.GOOGLE_ADS]: 'Google Ads',
  [MUSTERI_KAYNAK.LINKEDIN]: 'LinkedIn',
};

export const MUSTERI_KAYNAK_COLORS: Record<MusteriKaynak, string> = {
  [MUSTERI_KAYNAK.SHOPIFY]: 'bg-blue-100 text-blue-800',
  [MUSTERI_KAYNAK.TRENDYOL]: 'bg-orange-100 text-orange-800',
  [MUSTERI_KAYNAK.HEPSIBURADA]: 'bg-yellow-100 text-yellow-800',
  [MUSTERI_KAYNAK.HARICI]: 'bg-gray-100 text-gray-800',
  [MUSTERI_KAYNAK.SCRAPING]: 'bg-purple-100 text-purple-800',
  [MUSTERI_KAYNAK.FUAR]: 'bg-pink-100 text-pink-800',
  [MUSTERI_KAYNAK.B2B_SAHA]: 'bg-indigo-100 text-indigo-800',
  [MUSTERI_KAYNAK.REFERANS]: 'bg-teal-100 text-teal-800',
  [MUSTERI_KAYNAK.WHATSAPP]: 'bg-lime-100 text-lime-800',
  [MUSTERI_KAYNAK.INSTAGRAM]: 'bg-rose-100 text-rose-800',
  [MUSTERI_KAYNAK.FACEBOOK]: 'bg-sky-100 text-sky-800',
  [MUSTERI_KAYNAK.GOOGLE_ADS]: 'bg-amber-100 text-amber-800',
  [MUSTERI_KAYNAK.LINKEDIN]: 'bg-cyan-100 text-cyan-800',
};

export const MUSTERI_KAYNAK_OPTIONS = ALL_MUSTERI_KAYNAK.map((v) => ({
  value: v,
  label: MUSTERI_KAYNAK_LABELS[v],
}));

// Bilinmeyen kaynak gizlenmez, kodun kendisi görünür; boş değer "—".
export const musteriKaynakLabel = (value?: string | null): string =>
  value ? MUSTERI_KAYNAK_LABELS[value as MusteriKaynak] || value : '—';

// ── Lead durumu ──
export const LEAD_DURUM_LABELS: Record<LeadDurum, string> = {
  [LEAD_DURUM.YENI]: 'Yeni',
  [LEAD_DURUM.ILETISIME_GECILDI]: 'İletişime Geçildi',
  [LEAD_DURUM.ILGILI]: 'İlgili',
  [LEAD_DURUM.TEKLIF_VERILDI]: 'Teklif Verildi',
  [LEAD_DURUM.ONAYLANDI]: 'Onaylandı',
  [LEAD_DURUM.REDDEDILDI]: 'Reddedildi',
  [LEAD_DURUM.TAKIPTE]: 'Takipte',
};

export const LEAD_DURUM_COLORS: Record<LeadDurum, string> = {
  [LEAD_DURUM.YENI]: 'bg-sky-100 text-sky-800',
  [LEAD_DURUM.ILETISIME_GECILDI]: 'bg-blue-100 text-blue-800',
  [LEAD_DURUM.ILGILI]: 'bg-green-100 text-green-800',
  [LEAD_DURUM.TEKLIF_VERILDI]: 'bg-yellow-100 text-yellow-800',
  [LEAD_DURUM.ONAYLANDI]: 'bg-emerald-100 text-emerald-800',
  [LEAD_DURUM.REDDEDILDI]: 'bg-red-100 text-red-800',
  [LEAD_DURUM.TAKIPTE]: 'bg-orange-100 text-orange-800',
};

export const LEAD_DURUM_OPTIONS = ALL_LEAD_DURUM.map((v) => ({
  value: v,
  label: LEAD_DURUM_LABELS[v],
}));

// Bilinmeyen durum gizlenmez, kodun kendisi görünür; boş değer "—".
export const leadDurumLabel = (value?: string | null): string =>
  value ? LEAD_DURUM_LABELS[value as LeadDurum] || value : '—';

// ── Sektör (musteriler.sektor — VARCHAR kolon, ENUM DEĞİL) ──
// Değer kümesi rota 3.2'de shared'a taşındı (backend Joi şeması ikinci tüketici
// oldu); burada yalnız etiketler ve açılır liste durur. SAAS-COUPLING notu
// kümenin yanında, `shared/constants/customer.ts` içinde.
export const SEKTOR_LABELS: Record<Sektor, string> = {
  [SEKTOR.VETERINER]: 'Veteriner',
  [SEKTOR.PET_KUAFOR]: 'Pet Kuaför',
  [SEKTOR.DOVME]: 'Dövme',
  [SEKTOR.HASTANE]: 'Hastane',
  [SEKTOR.SPA]: 'SPA',
  [SEKTOR.MASAJ_SALONU]: 'Masaj Salonu',
  [SEKTOR.MEDIKAL]: 'Medikal',
};

export const SEKTOR_OPTIONS = ALL_SEKTOR.map((v) => ({
  value: v,
  label: SEKTOR_LABELS[v],
}));

// ── Aktivite kanalı (musteri_aktiviteleri.kanal — VARCHAR kolon) ──
// SAAS-COUPLING: numaralar TrioCare'in hatlarıdır — hardcoded — extraction'da
// tenant ayarına taşınır; hat eklemek kod değil veri işi olmalı.
export const KANAL_OPTIONS = [
  { value: '0533 554 35 62', label: '0533 554 35 62' },
  { value: '0533 378 35 62', label: '0533 378 35 62' },
];

// ── Aktivite türü ──
// Etiket haritası ENUM'un TAMAMINI kapsar (SISTEM dahil); açılır liste ise
// SISTEM'siz alt kümeden türer — o değeri yalnız sistem yazar, kullanıcı seçemez.
// Aynı alt küme backend Joi doğrulamasında da kullanılır (tek kaynak).
export const AKTIVITE_TURU_LABELS: Record<AktiviteTuru, string> = {
  [AKTIVITE_TURU.ARAMA]: 'Arama',
  [AKTIVITE_TURU.WHATSAPP]: 'WhatsApp',
  [AKTIVITE_TURU.WHATSAPP_KONUSMA]: 'WhatsApp Konuşma',
  [AKTIVITE_TURU.EMAIL]: 'E-posta',
  [AKTIVITE_TURU.ZIYARET]: 'Ziyaret',
  [AKTIVITE_TURU.SUNUM]: 'Sunum',
  [AKTIVITE_TURU.NUMUNE_GONDERIMI]: 'Numune Gönderimi',
  [AKTIVITE_TURU.NOT]: 'Not',
  [AKTIVITE_TURU.SISTEM]: 'Sistem',
};

export const AKTIVITE_TURU_OPTIONS = SECILEBILIR_AKTIVITE_TURLERI.map((v) => ({
  value: v,
  label: AKTIVITE_TURU_LABELS[v],
}));

// ── Aktivite sonucu ──
// Etiket haritası ENUM'un TAMAMINI kapsar — IPTAL dahil. Eskiden kapsamıyordu:
// `AKTIVITE_SONUC_OPTIONS` hem filtre listesiydi hem etiket kaynağıydı ve IPTAL
// içinde yoktu, bu yüzden takibi iptal edilmiş beş aktivite zaman çizelgesinde
// Türkçe etiket yerine ham "IPTAL" görünüyordu. `TEKLIF_DURUMU`'nun ikizi
// (rota 2.2), farkı canlıda görünür olmasıydı.
export const AKTIVITE_SONUC_LABELS: Record<AktiviteSonuc, string> = {
  [AKTIVITE_SONUC.CEVAP_YOK]: 'Cevap Yok',
  [AKTIVITE_SONUC.ILGILI]: 'İlgili',
  [AKTIVITE_SONUC.ILGISIZ]: 'İlgisiz',
  [AKTIVITE_SONUC.TEKRAR_ARANACAK]: 'Tekrar Aranacak',
  [AKTIVITE_SONUC.TEKLIF_VERILDI]: 'Teklif Verildi',
  [AKTIVITE_SONUC.SIPARIS_ALINDI]: 'Sipariş Alındı',
  [AKTIVITE_SONUC.IPTAL]: 'İptal',
};

// Sıradan aktivite formu/filtresi — IPTAL hariç (bkz. shared'daki gerekçe).
export const AKTIVITE_SONUC_OPTIONS = SECILEBILIR_AKTIVITE_SONUCLARI.map((v) => ({
  value: v,
  label: AKTIVITE_SONUC_LABELS[v],
}));

// Takip kapatma penceresi — kümenin TAMAMI. IPTAL orada "takibi bırak"
// anlamına geldiği için etiketi bu bağlama özel genişletilir; ENUM'a yeni bir
// sonuç eklenirse iki liste de kendiliğinden büyür.
const TAKIP_KAPATMA_EK_ETIKET: Partial<Record<AktiviteSonuc, string>> = {
  [AKTIVITE_SONUC.IPTAL]: 'İptal (takibi bırak)',
};

export const TAKIP_KAPATMA_SONUC_OPTIONS = ALL_AKTIVITE_SONUC.map((v) => ({
  value: v,
  label: TAKIP_KAPATMA_EK_ETIKET[v] || AKTIVITE_SONUC_LABELS[v],
}));

// Bilinmeyen sonuç GİZLENMEZ (rota 1.21 dersi): değerin kendisi görünür.
export const aktiviteSonucLabel = (value?: string | null): string =>
  value ? AKTIVITE_SONUC_LABELS[value as AktiviteSonuc] || value : '—';

// Aktivite formundaki sonuç açılır listesi. Kayıtta duran değer seçilebilir
// kümenin dışındaysa (bugün yalnız IPTAL, canlıda 5 aktivite) listeye EKLENİR —
// yoksa `Select` seçili değeri gösteremez ve alan boş görünür; kullanıcı sonucun
// silindiğini sanır. Rota 1.21'de kargo firmasında yaşanan hatanın aynısı.
// Veri kaybı yoktu (boş sonuç `undefined` gidiyor, model tanımsız alanı atlıyor),
// ama ekran yalan söylüyordu.
//
// Kural rota 2.9'da merkeze alındı: `degerFarkindaSecenekler`. Burası artık o
// kuralın aktivite sonucuna özel etiketleyicisinden ibaret.
export const aktiviteSonucSecenekleri = (
  mevcut?: string | null
): Secenek[] => degerFarkindaSecenekler(AKTIVITE_SONUC_OPTIONS, mevcut, aktiviteSonucLabel);

// ── Ödeme yöntemi (odeme_kayitlari.odeme_yontemi) ──
// Eskiden `types/payment.ts` içindeydi — etiket/liste yeri burası (rota 2.2).
// Sipariş ödeme TÜRÜ (`PAYMENT_TYPE_LABELS`, yukarıda) ile ayrı kolon, ayrı ENUM.
export const ODEME_YONTEMI_LABELS: Record<OdemeYontemiType, string> = {
  [ODEME_YONTEMI.NAKIT]: 'Nakit',
  [ODEME_YONTEMI.HAVALE]: 'Havale/EFT',
  [ODEME_YONTEMI.KREDI_KARTI]: 'Kredi Kartı',
  [ODEME_YONTEMI.DIGER]: 'Diğer',
};

export const ODEME_YONTEMI_OPTIONS = ALL_ODEME_YONTEMI.map((v) => ({
  value: v,
  label: ODEME_YONTEMI_LABELS[v],
}));

export const odemeYontemiLabel = (value?: string | null): string =>
  value ? ODEME_YONTEMI_LABELS[value as OdemeYontemiType] || value : '—';

// ── Hepsiburada sipariş kontrolü (Entegrasyon Ayarları) ──
// Değerleri backend kontrol servisi üretir; bilinmeyen değer ham gösterilir.
export const HB_KONTROL_FARK_LABELS: Record<HbKontrolFarkTuruType, string> = {
  [HB_KONTROL_FARK_TURU.CRMDE_YOK]: "CRM'de yok",
  [HB_KONTROL_FARK_TURU.KALEM_EKSIK]: 'Kalem eksik',
  [HB_KONTROL_FARK_TURU.SILINMIS]: "CRM'de silinmiş",
  [HB_KONTROL_FARK_TURU.BASKA_MAGAZADA]: 'Başka mağazada',
  [HB_KONTROL_FARK_TURU.PAKET_BAGI_YOK]: 'Paket bağı yok',
  [HB_KONTROL_FARK_TURU.TESLIM_FARKI]: 'Teslim farkı',
  [HB_KONTROL_FARK_TURU.IPTAL_FARKI]: "İptal CRM'e yansımamış",
  [HB_KONTROL_FARK_TURU.IPTAL_TERS]: "CRM'de iptal, Hepsiburada'da gönderilmiş",
  [HB_KONTROL_FARK_TURU.TANINMAYAN_DURUM]: 'Tanınmayan durum',
  [HB_KONTROL_FARK_TURU.CIFT_KAYIT]: 'Çift kayıt',
  [HB_KONTROL_FARK_TURU.OKUNAMADI]: 'Okunamadı',
  [HB_KONTROL_FARK_TURU.BICIM_TANINMADI]: 'Biçim tanınmadı',
  [HB_KONTROL_FARK_TURU.SAYFA_SINIRI]: 'Sayfa sınırı aşıldı',
};

export const hbKontrolFarkLabel = (value?: string | null): string =>
  value ? HB_KONTROL_FARK_LABELS[value as HbKontrolFarkTuruType] || value : '—';

export const HB_KONTROL_LISTESI_LABELS: Record<HbKontrolListesiType, string> = {
  [HB_KONTROL_LISTESI.BEKLEYEN_KALEMLER]: 'Bekleyen kalemler',
  [HB_KONTROL_LISTESI.PAKETLER]: 'Paketler',
  [HB_KONTROL_LISTESI.KARGOYA_VERILENLER]: 'Kargoya verilenler',
  [HB_KONTROL_LISTESI.TESLIM_EDILENLER]: 'Teslim edilenler',
};

export const hbKontrolListesiLabel = (value?: string | null): string =>
  value ? HB_KONTROL_LISTESI_LABELS[value as HbKontrolListesiType] || value : '—';

export const HB_KONTROL_ATLAMA_NEDENI_LABELS: Record<HbKontrolAtlamaNedeniType, string> = {
  [HB_KONTROL_ATLAMA_NEDENI.KIMLIK_YOK]: 'Satıcı kimliği tanımlı değil',
  [HB_KONTROL_ATLAMA_NEDENI.PASIF]: 'Mağaza pasif',
};

export const hbKontrolAtlamaNedeniLabel = (value?: string | null): string =>
  value ? HB_KONTROL_ATLAMA_NEDENI_LABELS[value as HbKontrolAtlamaNedeniType] || value : '—';

export const HB_KONTROL_DUZELTME_LABELS: Record<HbKontrolDuzeltmeType, string> = {
  [HB_KONTROL_DUZELTME.ACILDI]: 'Sipariş açıldı',
  [HB_KONTROL_DUZELTME.PAKET]: 'Paket numarası yazıldı',
  [HB_KONTROL_DUZELTME.TESLIM]: 'Teslim işaretlendi',
  [HB_KONTROL_DUZELTME.IPTAL]: 'İptal yazıldı',
};

export const hbKontrolDuzeltmeLabel = (value?: string | null): string =>
  value ? HB_KONTROL_DUZELTME_LABELS[value as HbKontrolDuzeltmeType] || value : '—';

export const HB_KONTROL_DUZELTILMEME_NEDENI_LABELS: Record<HbKontrolDuzeltilmemeNedeniType, string> = {
  [HB_KONTROL_DUZELTILMEME_NEDENI.DURUM]: 'Kalem durumu tanınmadı',
  [HB_KONTROL_DUZELTILMEME_NEDENI.TALEP_ACIK]: 'Kalemde açık talep var (iade ya da değişim), elle açılmalı',
  [HB_KONTROL_DUZELTILMEME_NEDENI.EKSIK_ALAN]: 'Zorunlu bilgi eksik ya da hatalı',
  [HB_KONTROL_DUZELTILMEME_NEDENI.YENI_SIPARIS]: 'Sipariş bir saatten yeni, bildirimi bekleniyor',
  [HB_KONTROL_DUZELTILMEME_NEDENI.ODEME_BEKLIYOR]: 'Ödeme tamamlanmamış',
  [HB_KONTROL_DUZELTILMEME_NEDENI.INDIRIMLI]: 'İndirimli sipariş, elle açılmalı',
  [HB_KONTROL_DUZELTILMEME_NEDENI.SONRADAN_KALEM]: 'Kalem siparişe sonradan eklenmiş, elle açılmalı',
  [HB_KONTROL_DUZELTILMEME_NEDENI.ELLE_GIRILMIS_OLABILIR]: 'Numara başka kaynaklı bir kayıtta, elle girilmiş olabilir',
  [HB_KONTROL_DUZELTILMEME_NEDENI.ELLE_GIRILMIS]: 'CRM kaydı elle girilmiş, elle düzeltilmeli',
  [HB_KONTROL_DUZELTILMEME_NEDENI.TESLIM_EDILEMEDI]: 'Teslim edilemedi bildirimi alınmış',
  [HB_KONTROL_DUZELTILMEME_NEDENI.FATURA_DURUMU]: 'Fatura durumu uygun değil, elle düzeltilmeli',
  [HB_KONTROL_DUZELTILMEME_NEDENI.HATA]: 'Yazılamadı, ayrıntı sunucu logunda',
};

export const hbKontrolDuzeltilmemeNedeniLabel = (value?: string | null): string =>
  value ? HB_KONTROL_DUZELTILMEME_NEDENI_LABELS[value as HbKontrolDuzeltilmemeNedeniType] || value : '—';

// Türkiye Resmi ve Dini Tatiller
// REMOVED: Hardcoded HOLIDAYS array - now using date-holidays package
// See: shared/utils/holidayHelper.js for automatic holiday calculation
